
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#FFF","cx":"20","cy":"20","r":"15"}}),_c('path',{attrs:{"fill":"none","stroke":"#00518F","stroke-width":"3","d":"M31.16 15.59a12 12 0 00-10.41-7.57"}}),_v(','),_c('path',{attrs:{"fill":"none","stroke":"#1CD8AA","stroke-width":"3","d":"M19.25 8.02a12 12 0 1012.37 8.99"}}),_c('text',{staticStyle:{"font":"400 11px arial,helvetica,sans-serif","text-shadow":"none"},attrs:{"x":"20","y":"20","text-anchor":"middle","alignment-baseline":"central"}},[_v('5')])])
          )
        }
      }
    